module.exports = __webpack_public_path__ + "static/media/img_account.105ccd8a.png";